// Kinetic Live Orders Popup JavaScript
(function() {
  // Array of sample orders
  const orders = [
    { name: "Lalonie", location: "CT", product: "Kinetic 1 Bottle", time: "28 minutes ago" },
    { name: "Eslam", location: "OR", product: "Kinetic 1 Bottle", time: "56 minutes ago" },
    { name: "E", location: "VA", product: "Kinetic 1 Bottle", time: "1 hour 26 minutes ago" },
    { name: "Will", location: "MA", product: "Kinetic 1 Bottle", time: "1 hour 57 minutes ago" },
    { name: "Timothy", location: "NE", product: "Kinetic 1 Bottle", time: "2 hours 29 minutes ago" },
    { name: "Craig", location: "PA", product: "Kinetic 1 Bottle", time: "3 hours 2 minutes ago" },
    { name: "Omar", location: "CA", product: "Kinetic 1 Bottle", time: "3 hours 36 minutes ago" },
    { name: "Yvette", location: "CA", product: "Kinetic 1 Bottle", time: "4 hours 11 minutes ago" },
    { name: "Nigel", location: "NY", product: "Kinetic 1 Bottle", time: "4 hours 47 minutes ago" },
    { name: "Lamar", location: "SC", product: "Kinetic 1 Bottle", time: "5 hours 24 minutes ago" },
    { name: "Stefan", location: "CA", product: "Kinetic 1 Bottle", time: "32 minutes ago" },
    { name: "Jared", location: "CA", product: "Kinetic 1 Bottle", time: "1 hour 5 minutes ago" },
    { name: "Stephen", location: "IL", product: "Kinetic 1 Bottle", time: "1 hour 39 minutes ago" },
    { name: "Jarred", location: "FL", product: "Kinetic 1 Bottle", time: "2 hours 14 minutes ago" },
    { name: "Shopan", location: "IA", product: "Kinetic 1 Bottle", time: "2 hours 50 minutes ago" },
    { name: "D'Andre", location: "IL", product: "Kinetic 1 Bottle", time: "3 hours 27 minutes ago" },
    { name: "David", location: "AZ", product: "Kinetic 1 Bottle", time: "4 hours 5 minutes ago" },
    { name: "Salumu", location: "FL", product: "Kinetic 1 Bottle", time: "4 hours 44 minutes ago" },
    { name: "Olena", location: "AK", product: "Kinetic 1 Bottle", time: "5 hours 24 minutes ago" },
    { name: "Ruth", location: "CA", product: "Kinetic 1 Bottle", time: "6 hours 5 minutes ago" },
    { name: "Elihoret", location: "NY", product: "Kinetic 1 Bottle", time: "25 minutes ago" },
    { name: "Jarred", location: "FL", product: "Kinetic 1 Bottle", time: "51 minutes ago" },
    { name: "Greg", location: "IN", product: "Kinetic 1 Bottle", time: "1 hour 18 minutes ago" },
    { name: "Willie", location: "KY", product: "Kinetic 1 Bottle", time: "1 hour 46 minutes ago" },
    { name: "Shawde", location: "PA", product: "Kinetic 1 Bottle", time: "2 hours 15 minutes ago" },
    { name: "Jonathan", location: "CA", product: "Kinetic 1 Bottle", time: "2 hours 45 minutes ago" },
    { name: "Eerric", location: "MO", product: "Kinetic 1 Bottle", time: "3 hours 16 minutes ago" },
    { name: "Yvette", location: "CA", product: "Kinetic 1 Bottle", time: "3 hours 48 minutes ago" },
    { name: "Trisha", location: "IL", product: "Kinetic 1 Bottle", time: "4 hours 21 minutes ago" },
    { name: "Herxia", location: "LA", product: "Kinetic 1 Bottle", time: "4 hours 55 minutes ago" },
    { name: "Jannet", location: "WA", product: "Kinetic 1 Bottle", time: "5 hours 30 minutes ago" }
  ];

  // Display popup function
  function showLiveOrder() {
    const randomOrder = orders[Math.floor(Math.random() * orders.length)];
    const popup = document.getElementById('live-orders-popup');
    popup.innerHTML = `
      <div class="popup-content">
        <div class="popup-image">
          <img style="border-radius: 5px;" src="https://cdn.shopify.com/s/files/1/2443/2395/files/Kinetic-WatermelonCandy_Zoom.png?v=1733781878" alt="Product Image">
          <span class="glow-dot"></span>
        </div>
        <div class="popup-text">
          <div class="popup-line">
            <div class="name-location"><strong>${randomOrder.name} from ${randomOrder.location}</strong></div>
          </div>
          <div class="popup-line product-name"><span class="ordered-text">ordered</span> <strong><span class="product-text">${randomOrder.product}</span></strong></div>
          <div class="popup-line order-time">${randomOrder.time}</div>
          <div class="verified-buyer-badge">Verified Buyer</div>
        </div>
      </div>
    `;
    popup.style.display = 'block';

    setTimeout(() => {
      popup.classList.add('popup-hide');
    }, 6000); // Show for 5 seconds

    setTimeout(() => {
      popup.style.display = 'none';
      popup.classList.remove('popup-hide');
      setTimeout(showLiveOrder, getRandomTimeInterval());
    }, 6500);
  }

  // Random time intervals between popups
  function getRandomTimeInterval() {
    const intervals = [20000, 20000, 20000]; // 20s, 20s, 20s
    return intervals[Math.floor(Math.random() * intervals.length)];
  }

  // Start the popup display
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(showLiveOrder, getRandomTimeInterval());
  });
})();
